import type { ReactElement } from "react";
import type { Layout } from "@kundeninfo/api-client";
import type { Entwurf } from "./layoutEntwurf.js";

/**
 * Die REGISTER der Gestaltung (Spec, Oberfläche, rechts): Marke, Seite, Sektionen,
 * Tabelle, Blöcke, Texte. Welche es gibt, sagt der Editor über `eintraege` — so wächst
 * die Liste mit K9/K10, ohne dass dieses Gerüst sich ändert.
 */

export type RegisterId = "marke" | "seite" | "sektionen" | "tabelle" | "bloecke" | "texte";

export type PanelProps = {
  stand: Layout;
  entwurf: Entwurf;
  feldFehler: Record<string, string>;
  belegart: string;
  onEntwurf: (neu: Entwurf) => void;
  onFeldVerlassen: () => void;
};

export type RegisterEintrag = {
  id: RegisterId; label: string; panel: (p: PanelProps) => ReactElement;
};

export function LayoutRegister(p: PanelProps & {
  eintraege: readonly RegisterEintrag[]; aktiv: RegisterId; onAktiv: (id: RegisterId) => void;
}): ReactElement {
  const aktiv = p.eintraege.find((e) => e.id === p.aktiv) ?? p.eintraege[0];
  return (
    <div className="lay__register">
      <div className="lay__reiter" role="tablist" aria-label="Gestaltung">
        {p.eintraege.map((e) => (
          <button key={e.id} type="button" role="tab" id={`lay-reiter-${e.id}`}
            aria-selected={e.id === aktiv?.id} aria-controls="lay-registerinhalt"
            className={`lay__reiterknopf${e.id === aktiv?.id ? " lay__reiterknopf--aktiv" : ""}`}
            onClick={() => p.onAktiv(e.id)}>
            {e.label}
          </button>
        ))}
      </div>
      <div id="lay-registerinhalt" role="tabpanel"
        aria-labelledby={aktiv === undefined ? undefined : `lay-reiter-${aktiv.id}`}>
        {aktiv?.panel(p)}
      </div>
    </div>
  );
}
